import { Calendar, Clock, MapPin, Ticket } from "lucide-react";
import Logo from "./Logo";
import Reveal from "./Reveal";

const EVENT_INFO = [
    { icon: Calendar, text: "31 October 2026 (Saturday)" },
    { icon: Clock, text: "8:30 AM – 5:00 PM" },
    { icon: MapPin, text: "Connexion Conference & Event Centre, Bangsar, Kuala Lumpur" },
    { icon: Ticket, text: "FREE ENTRY — Limited 100 pax" },
];

const Footer = () => (
    <footer
        data-testid="footer"
        className="relative border-t border-white/10 bg-black/40 pb-28 pt-16 md:pb-10"
    >
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="grid gap-12 md:grid-cols-3">
                <div>
                    <Logo size={40} />
                    <p className="mt-6 max-w-xs text-sm leading-relaxed text-white/55">
                        Penganjuran bersama Queen of Dollars (QOD) &amp; Cikgu
                        Irfan. Featuring HFM branding.
                    </p>
                    <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.22em] text-white/50">
                        Edisi Kuala Lumpur • 2026
                    </p>
                </div>

                <div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/45">
                        Maklumat acara
                    </p>
                    <ul className="mt-5 space-y-3.5">
                        {EVENT_INFO.map((e, i) => (
                            <li
                                key={i}
                                className="flex items-start gap-3 text-sm text-white/70"
                            >
                                <e.icon
                                    size={15}
                                    className="mt-0.5 shrink-0 text-white/80"
                                />
                                {e.text}
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/45">
                        Legal
                    </p>
                    <div className="mt-5 flex gap-6">
                        <a
                            href="#/privacy-policy"
                            data-testid="privacy-policy-link"
                            className="text-sm text-white/70 underline-offset-4 transition-colors duration-300 hover:text-white hover:underline"
                        >
                            Privacy Policy
                        </a>
                        <a
                            href="#terms-and-conditions"
                            data-testid="terms-conditions-link"
                            className="text-sm text-white/70 underline-offset-4 transition-colors duration-300 hover:text-white hover:underline"
                        >
                            Terms &amp; Conditions
                        </a>
                    </div>
                    <p className="mt-6 text-xs leading-relaxed text-white/45">
                        "Trading leveraged financial products involves
                        significant risk and may not be suitable for everyone.
                        This seminar is for educational purposes only. No
                        trading results or profits are guaranteed."
                    </p>
                </div>
            </div>

            <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/5 pt-6 sm:flex-row sm:items-center">
                <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/35">
                    © 2026 Engulf Summit — QOD &amp; Cikgu Irfan
                </p>
                <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/35">
                    Educational purposes only. Trading involves risk.
                </p>
            </div>
        </div>
    </footer>
);

export default Footer;
